import React, { forwardRef, Suspense } from 'react'
import type ReCAPTCHADefinition from 'react-google-recaptcha'
import { useFormState } from 'react-hook-form'

const ReCAPTCHA = React.lazy(() => import('react-google-recaptcha'))

export interface RHFRecaptchaProps {
  siteKey: string
}

export const RHFRecaptcha = forwardRef<ReCAPTCHADefinition, RHFRecaptchaProps>(
  ({ siteKey }, ref) => {
    const { isDirty } = useFormState()

    // Lazy-load the recaptcha component by not rendering it until the first time the user
    // edits a form field
    return isDirty ? (
      // Suspense component is required here for some reason, otherwise React throws an error
      <Suspense>
        <ReCAPTCHA ref={ref} sitekey={siteKey} size="invisible" />
      </Suspense>
    ) : null
  }
)
